import React, { useEffect, useState, useContext } from "react";
import "./Banner.css";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faMapMarkerAlt,
  faBriefcase,
} from "@fortawesome/free-solid-svg-icons";
import { Context } from "../../../../utils/context";
import Select from "react-select";
import SearchBar from "./SearchBar/SearchBar";

const Banner = () => {
  const navigate = useNavigate();

  // Destructuring your specific Context variables
  const { getData, Select2Data, setCitySearch } = useContext(Context);

  // Component States
  const [cities, setCities] = useState([]);
  const [selectCity, setSelectCity] = useState(null);
  const [searchTitle, setSearchTitle] = useState("");
  const [selectedExperience, setSelectedExperience] = useState(null);

  // Dynamic Static Experience Dropdown values
  const experienceOptions = [
    { value: "0", label: "Fresher (0 Years)" },
    { value: "1", label: "1 Year" },
    { value: "2", label: "2 Years" },
    { value: "3", label: "3 Years" },
    { value: "5", label: "5+ Years" },
  ];

  // Fetch Masters / City Data on Mount
  const getMasters = async () => {
    try {
      const res = await getData(`/without-login/master/all-cities`);
      if (res?.success) {
        setCities(await Select2Data(res.data, "city_id"));
      }
    } catch (error) {
      console.error("Error retrieving cities: ", error);
    }
  };

  useEffect(() => {
    getMasters();
  }, []);

  // Form Submission Route Trigger
  const handleSearch = () => {
    setCitySearch(selectCity);

    const cityId = selectCity?.value || "";
    const expValue = selectedExperience?.value || "";

    navigate(
      `/jobexp?id=${searchTitle}&city_id=${cityId}&experience=${expValue}`,
    );
  };

  return (
    <section className="home-banner-section">
      <div className="container">
        <div className="banner-layout-container">
          {/* Left Aspect: Celebrating Professional Asset Graphic */}
          <div className="left-hero-image">
            <img
              src="/assets/Images/banner/bumrah.png"
              alt="Candidate celebrating job milestone"
              onError={(e) => {
                e.target.style.display = "none";
              }}
            />
          </div>

          {/* Core Feature: Job Hub UI & Search Elements */}
          <div className="center-search-block">
            <p className="banner-tagline">Connecting Talent with Opportunity</p>
            <h1 className="banner-main-title">
              Revamp Your Portfolio, <br />
              <span>Ace Your Job Hunt!</span>
            </h1>
            <p className="banner-subtitle">
              Need Talent? Reach 350M+ Candidates in Seconds. Post on Placement
              Now!
            </p>

            <SearchBar
              searchTitle={searchTitle}
              setSearchTitle={setSearchTitle}
              selectCity={selectCity}
              setSelectCity={setSelectCity}
              cities={cities}
              selectedExperience={selectedExperience}
              setSelectedExperience={setSelectedExperience}
              experienceOptions={experienceOptions}
              handleSearch={handleSearch}
            />
          </div>

          {/* Right Aspect: Vector Cricket Graphics Design Element */}
          <div className="right-hero-image">
            <img
              src="/assets/Images/banner/wicket.png"
              alt="Cricket stumps layout theme illustration"
              onError={(e) => {
                e.target.style.display = "none";
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
